import {
  ChangeDetectorRef,
  Component,
  HostBinding,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
} from "@angular/core";
import { ReportsService } from "src/app/services/reports.service";
import { Subscription } from "rxjs";
import { BaseChartDirective } from "ng2-charts";
import { GraphResult } from "@models/graph";
import { BaseGraphComponent } from "../base-graph/base-graph.component";

@Component({
  selector: "usage-graph-chart",
  templateUrl: "./usage-graph.component.html",
  styleUrls: ["./usage-graph.component.scss"],
})
export class UsageGraphComponent
  extends BaseGraphComponent
  implements OnInit, OnDestroy
{
  private _dataSubscription: Subscription;

  @ViewChild(BaseChartDirective) chart: BaseChartDirective;
  @Input() colors: string[]

  public labels: { name: string; color: string; count: number }[] = [];
  public features: GraphResult[] = null;
  public isMobile = window.innerWidth < 500;

  @HostBinding('style.--label-count')
  get labelCount() {
    return this.labels.length || 1;
  }

  public constructor(
    private readonly _reportsService: ReportsService,
    private readonly _changeDetectorRef: ChangeDetectorRef
  ) {
    const colors = [
      "#0A2D82",
      "#2548A3",
      "#778CCE",
      "#9EADDC",
      "#E8EBF6"
    ];

    super(_reportsService, { value: colors});
    this.colors = colors;
  }

  public ngOnInit(): void {
    this._dataSubscription = this._reportsService.salesReportStramSubject.subscribe(data => {
      if (!data|| data && data.length === 0) {
        this.hasData = false;
        return;
      }

      this.hasData = true;

      if (!this.chart) {
        this._changeDetectorRef.markForCheck();
        this._changeDetectorRef.detectChanges();
      }

      const results = data.map<GraphResult>(x => ({
        description: x.plataform,
        count: x.salesCount
      }));

      this.labels = this.getLabels(results, this.colors);
      super.updatePieChartData(results, this.chart);
    })
  }


  public ngOnDestroy(): void {
    this._dataSubscription.unsubscribe();
  }

  public clearGraphData(): void {
    this.labels = [];
    
    this.hasData = false;

    if (this.chart) {
      this.chart.data.labels = [];
      this.chart.data.datasets.forEach((dataset) => {
        dataset.data = [];
        dataset.backgroundColor = [];
      });

      this.chart.update();
    }
  }
}
